import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UsersService } from './users/users.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {

  constructor(private usersService: UsersService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.usersService.user$.pipe(
      map(user => {
        const isSuperAdmin = user && user.invitationCode === environment.superAdmin.key;
        if (!isSuperAdmin) {
          // If the user is not a super admin, redirect to an unauthorized page
          this.router.navigate(['/search']); // replace 'unauthorized' with the route you want to redirect non-admin users to
        }
        return isSuperAdmin;
      })
    );
  }
}
